import styled from "styled-components";

const VeriticalCenter  = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: start;
`

export default VeriticalCenter;